module.exports = __webpack_public_path__ + "img/imageAi.50ee4833.png";